import {Axios} from '../axios/axios'
//任务列表
export const adminLogin = (e) => {
  return Axios({
    url:"/adminapi/login",
    method:'POST',
    data:e
  })
}
//更新头像 adminapi/updateAdmin
export const updateAdmin = (e) => {
  return Axios({
    url:"/adminapi/updateAdmin",
    method:'POST',
    data:e
  })
}
//修改密码 adminapi/updatePassword
export const updatePassword = (e) => {
  return Axios({
    url:"/adminapi/updatePassword",
    method:'POST',
    data:e
  })
}
